import { Component, forwardRef } from '@angular/core';
import { TeamService } from '../../service/team.service';
import { combineLatest, Observable, of } from 'rxjs';
import { ContextService } from '../../../shared/services/context.service';
import { meldingenForTeamPage } from '../../../meldingen/config';
import { AangemeldeUser } from '../../../authentication/user';
import { TeamlidProfiel } from '../../model/teamlid.model';
import { TeamlidContext } from '../../../shared/model/context';
import { ProfielnaamPipe } from '../../../shared/pipes/profielnaam.pipe';
import { ParkourBackButtonDirective } from '../../../shared/directives/parkour-back-button.directive';
import { PageWithHeroComponent } from '../../../shared/components/page-with-hero/page-with-hero.component';
import { ProfielFotoOfJongerePipe } from '../../../shared/pipes/profiel-foto-of-jongere.pipe';
import { ParkourActionComponent, ParkourIconComponent } from '@parkour/ui';
import { ProfielFotoBadgeComponent } from '../../../shared/components/profiel-foto-badge/profiel-foto-badge.component';
import { AsyncPipe } from '@angular/common';
import { PageLayoutComponent } from '../../../shared/components/page-layout/page-layout.component';
import { TeamVerlatenSectionComponent } from '../../component/team-verlaten-section/team-verlaten-section.component';
import { TeammemberActionComponent } from '../../component/teammember-action/teammember-action.component';
import { getProfielnaam } from '../../../profiel/model/profiel-in-team';
import { ParkourDataPage } from '../../../shared/parkour-data-page';
import {
  IonBackButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonRefresher,
  IonRefresherContent,
  IonTitle,
  IonToolbar,
} from '@ionic/angular/standalone';
import { ParkourRefreshDirective } from '../../../shared/directives/parkour-refresh-directive';
import { PageContentDirective } from '../../../shared/directives/page-content.directive';
import {
  MarksMeldingenAsReadOnView,
  MeldingenToMarkAsRead,
} from '../../../shared/marks-meldingen-as-read';
import { CustomPageTitle } from '../../../shared/custom-page-title';
import AuthService from '../../../authentication/service/auth.service';

export type TeamTeamlidPageData = {
  teamlidContext: TeamlidContext;
  teamleden: Array<TeamlidProfiel>;
  user: AangemeldeUser;
};

@Component({
  standalone: true,
  templateUrl: './team-teamlid.page.html',
  imports: [
    ParkourBackButtonDirective,
    PageWithHeroComponent,
    ProfielFotoOfJongerePipe,
    ParkourActionComponent,
    ProfielFotoBadgeComponent,
    ParkourIconComponent,
    ProfielnaamPipe,
    AsyncPipe,
    PageLayoutComponent,
    TeamVerlatenSectionComponent,
    TeammemberActionComponent,
    IonRefresher,
    IonRefresherContent,
    ParkourRefreshDirective,
    IonBackButton,
    IonContent,
    IonTitle,
    IonButtons,
    IonToolbar,
    IonHeader,
    forwardRef(() => PageContentDirective),
  ],
})
export class TeamTeamlidPage
  extends ParkourDataPage<TeamTeamlidPageData>
  implements CustomPageTitle, MarksMeldingenAsReadOnView
{
  constructor(
    private readonly teamService: TeamService,
    private readonly contextService: ContextService,
    private readonly authService: AuthService,
  ) {
    super();
  }

  override retrieveMainData(): Observable<TeamTeamlidPageData> {
    return combineLatest({
      teamlidContext: this.contextService.teamlidContext$(),
      teamleden: this.teamService.teamleden$,
      user: this.authService.getAangemeldeUser$(),
    });
  }

  getMeldingenToMarkAsRead() {
    return of(new MeldingenToMarkAsRead(meldingenForTeamPage.specificMeldingen));
  }

  getCustomPageTitle() {
    return this.generateDefaultTitle(
      (data) => getProfielnaam(data.teamlidContext.jongereProfiel),
      'team.team',
    );
  }

  protected readonly of = of;
}
